import {
  KpiDataDocument,
  MetricV2Data,
  WoboDataSourceMessage,
  WoboKpiDataMessage,
} from './types';

/** Coerce iframe / PHP / form values to a finite number, else undefined. */
export function toMetricNumber(value: unknown): number | undefined {
  if (value == null || value === '') {
    return undefined;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
}

/** Parse raw iframe metric row into strict v2 shape (app-services contract). */
export function parseMetricV2Data(raw: {
  value?: unknown;
  label?: unknown;
  total?: unknown;
} | null | undefined): MetricV2Data {
  const value = toMetricNumber(raw?.value) ?? 0;
  const label = raw?.label != null ? String(raw.label) : '';
  const total = toMetricNumber(raw?.total);

  if (total !== undefined) {
    return { value, label, total };
  }
  return { value, label };
}

export function normalizeDataSourceMessage(raw: {
  id?: unknown;
  name?: unknown;
  type?: unknown;
  data?: { value?: unknown; label?: unknown; total?: unknown };
  extraData?: Record<string, unknown>;
  automateTargetFlag?: unknown;
}): WoboDataSourceMessage {
  return {
    id: raw.id != null ? (raw.id as string | number) : undefined,
    name: raw.name != null ? String(raw.name) : undefined,
    type: raw.type != null ? String(raw.type) : undefined,
    data: parseMetricV2Data(raw.data),
    extraData: raw.extraData,
    automateTargetFlag: raw.automateTargetFlag === true,
  };
}

/** Map POST `/api/kpidata` document (or partial) to wizard kpiData message. */
export function normalizeKpiDataMessage(
  raw: Partial<KpiDataDocument> & {
    automateTargetFlag?: unknown;
  },
): WoboKpiDataMessage {
  const automateTargetFlag =
    raw.automateTargetFlag === true || raw.automateTargetUpdate === true;

  const syncSource = raw.metricV2Data;

  return {
    _id: String(raw._id ?? ''),
    data: parseMetricV2Data(syncSource as { value?: unknown; label?: unknown; total?: unknown }),
    externalObjectName: raw.externalObjectName != null ? String(raw.externalObjectName) : undefined,
    automateTargetFlag,
    externalObjectExtra: raw.externalObjectExtra,
  };
}
